import { useTranslation } from 'react-i18next'

import { Checkbox, Text } from '@reveni-io/reveni-ui'

import { availableDiscounts } from './constants'
import * as Styles from './styles'

const CombineDiscountsSelector = ({ discounts, onChange, disabled }) => {
  const { t } = useTranslation()

  const handleCheckboxChange = (discountType, checked) => {
    onChange(discountType, checked)
  }

  const isCheckboxChecked = discountType => discounts?.includes(discountType)

  return (
    <Styles.Container>
      <Text type="titleS">{t('Combinación de descuentos')}</Text>
      <Text type="bodyMRegular">{t('El crédito en tienda emitido se podrá combinar con')}:</Text>
      <Styles.CheckboxContainer>
        <Checkbox
          checked={isCheckboxChecked(availableDiscounts.products)}
          onChange={e => handleCheckboxChange(availableDiscounts.products, e.target.checked)}
          label={t('Descuentos sobre productos')}
          disabled={disabled}
        />
        <Checkbox
          checked={isCheckboxChecked(availableDiscounts.orders)}
          onChange={e => handleCheckboxChange(availableDiscounts.orders, e.target.checked)}
          label={t('Descuentos sobre pedidos')}
          disabled={disabled}
        />
        <Checkbox
          checked={isCheckboxChecked(availableDiscounts.shipping)}
          onChange={e => handleCheckboxChange(availableDiscounts.shipping, e.target.checked)}
          label={t('Descuentos sobre el envío')}
          disabled={disabled}
        />
      </Styles.CheckboxContainer>
    </Styles.Container>
  )
}

export default CombineDiscountsSelector
